import { AfterViewInit, Component, Inject, ModelFunction, Optional, ViewChild, model } from '@angular/core';
import moment from 'moment';

import { StockModel } from '../stock.model';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StockModifyComponent } from '../modify/modify.component';
import { CurrencyPipe } from '../../../shared/pipes/currency.pipe';
import { SharesService } from '../../shares/shares.service';


@Component({
  selector: 'stock-create',
  standalone: false,
  templateUrl: './create.component.html',
  styleUrl: './create.component.scss'
})
export class StockCreateComponent implements AfterViewInit {
  
  public stock: any
  public shares: any

  @ViewChild('createForm', { static: true }) createForm: NgForm | undefined
  public errorMessage: any
  
  constructor(
    private dialogRef: MatDialogRef<StockModifyComponent>,
    private currencyPipe: CurrencyPipe,
    private shareService: SharesService
  ){
    this.stock = {
      id: Math.random().toFixed(3),
      share: '',
      date: new Date(),
      side: '',
      amount: 0,
      price: 0.00,
      tax: 0.00,
      total: 0.00
    }
  }

  async ngAfterViewInit(): Promise<void> {
    console.error('StockCreateComponent -> ngAfterViewInit')

    //Update total
    this.createForm?.valueChanges?.subscribe((input:any) => {
      console.error('StockCreateComponent -> createForm.valueChanges', input['stock.amount'], input['stock.price'], input['stock.tax'])

      if(input['stock.amount'] != undefined && input['stock.price'] != undefined && input['stock.tax'] != undefined )
        this.stock.total = ((parseInt(input['stock.amount']) * parseFloat(this.currencyPipe.transform(input['stock.price'], false))) + parseFloat(this.currencyPipe.transform(input['stock.tax'], false))).toFixed(2)
    })
    
    this.shares = await this.shareService.loadOptions('STOCK')
    console.error('ShareCreateComponent -> ngAfterViewInit', 'shares', this.shares)
  }

  async onSubmit() {
    console.error('StockCreateComponent -> onSubmit', this.stock, this.createForm?.valid)

    if (this.createForm?.valid)
      this.dialogRef.close({
        data: {
          response: 'Stock created!',
          values: { 
            ...this.stock, 
            amount: this.createForm.value['stock.amount'].toString(), 
            price: parseFloat(this.currencyPipe.transform(this.createForm.value['stock.price'], false)),
            tax: parseFloat(this.currencyPipe.transform(this.createForm.value['stock.tax'], false)),
            total: parseFloat(this.currencyPipe.transform(this.createForm.value['stock.total'], false)),
          }
        }
      })
    else
      this.errorMessage = "Errorrrrr"
  }
  
}
